<template>
  <div
    class="card shadow m-3 position-fixed right-0 top-0 pb-2"
    style="z-index: 1"
    ref="close"
  >
    <div class="card-body d-flex align-items-center">
      <div
        :class="{ rotate: !complete }"
        class="
          mr-3
          rounded-round
          d-flex
          align-items-center
          justify-content-center
          p-2
          border-2 border-primary
          text-primary
        "
        style="width: 50px; height: 50px"
      >
        <i class="fa-solid fa-hourglass-half fa-2x" />
      </div>
      <div>
        <div
          class="progress rounded-round mb-2"
          style="height: 12px"
        >
          <div
            class="progress-bar bg-primary rounded-round"
            :style="`width:${progressBarWidth}%;`"
          />
        </div>
        <div>
          {{ $t('Printing Shipping Label') }} {{ '(' + countRound + '/' + totalTracking + ').' }}
        </div>
      </div>
      <button
        @click="closeProgressPrint()"
        type="button"
        class="close align-self-start ml-2 mr-n1 mt-n2 text-muted"
      >
        <span>×</span>
      </button>
    </div>
    <div
      v-if="completePrintList"
      class="ml-3"
    >
      <a
        href="#collapse-icon2"
        class="collapsed font-size-sm text-underline custom-hover"
        data-toggle="collapse"
      >
        <span>{{ $t('View List of Files') }}</span> <i class="fa-light fa-angle-down" />
      </a>
    </div>
    <!-- showLogPrint -->
    <div
      v-if="showLogPrint"
      style="max-width: 320px;"
    >
      <div
        class="collapse"
        id="collapse-icon2"
      >
        <div
          :class="['pl-0 pt-0 ml-3 mr-3', completePrintList.length ? '' : '']"
          style="max-height: 600px; overflow-x: hidden; overflow-y: auto;"
        >
          <div
            v-for="(data, i) in completePrintList"
            :key="'list'+i"
            class="border-bottom font-size-sm pb-1 pt-1"
          >
            <a
              :href="data.url"
              target="_blank"
              class="pl-3"
            >
              <span>{{ formatFileName(data.file_name) }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- showLogError -->
    <div
      v-if="showLogError"
      class="ml-3 mt-1"
    >
      <a
        href="#collapse-icon"
        class="collapsed font-size-sm text-danger text-underline custom-hover"
        data-toggle="collapse"
      >
        <span class="text-danger">{{ $t('Found An Error') }}</span> <i class="fa-light fa-angle-down text-danger" />
      </a>
    </div>
    <div
      v-if="showLogError"
      style="max-width: 320px;"
    >
      <div
        class="collapse"
        id="collapse-icon"
      >
        <div
          class="pl-0 pt-0 ml-3 mr-3"
          style="max-height: 600px; overflow-x: hidden; overflow-y: auto;"
        >
          <div class="list mb-2">
            <div
              v-for="(data, i) in errorPrintList"
              :key="'list'+i"
              class="font-size-sm text-danger border-bottom pb-1 pt-1"
            >
              <div class="pl-3">
                <span>({{ data.order_number }}) {{ $t('The system is currently processing a request for information from the partner. Please wait a moment and try again later.') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/services/endpoint/tenant.service";
window.Pusher = require('pusher-js');
import Cookies from "js-cookie";
import { v4 as uuid } from 'uuid';

export default {
    data() {
        const vm = this;
        return {
            closeModal: false,
            errorPrintList: [],
            totalTracking: 0,
            countPrintTracking: 0,
            showLogError: false,
            complete: false,
            loopPrint: '',
            countCreateTracking: 0,
            countProgress: 20,
            countchunk : 100,
            second : 0,
            refreshIntervalId : null,
            printedList : [],
            showLogPrint: false,
            completePrintList: [],
            mergePrintList: [],
            printRound: 0,
            user: JSON.parse(Cookies.get('user')),
            tenant: JSON.parse(Cookies.get('tenant')),
            countRound: 0,
            wssMessages: [],
        }
    },
    props: {
      listDataPrint:{
        type: Object,
        default: () => ({})
      }
    },
    watch:{
      "listDataPrint"(nval, oval){
        if(nval){
          this.openWebsocket();
        }
      }
    },
    computed: {
      progressBarWidth() {
        return this.countPrintTracking;
      },
      checkListReady() {
        return this.$store.state.shipment.checkListReady;
      },
    },
    methods: {
        closeProgressPrint() {
          this.$toastr.s(
            this.$t("Print Shipping Label Success."),
            "<i class='fa-solid fa-circle-check mr-2'></i>" +
              this.$t("Success")
          );
          this.completePrintList = [];
          this.printedList = [];
          this.errorPrintList = [];
          this.$store.dispatch("shipment/updateShipmentDataTable", true);
          this.$store.dispatch("shipment/isModalModalPrintTiktok", false);
          clearInterval(this.refreshIntervalId);
          this.$store.dispatch("shipment/isModalModalPrintTiktok", false);
        },
        async generateLabelFunc(){
          let payload = this.$store.state.shipment.checkListPrintTiktok;
          this.countPrintTracking = 0
          this.countCreateTracking = 0
          this.countProgress = 1
          this.second = 0
          this.totalTracking = payload.param.shipment.length;
          this.loopPrint = Math.ceil(this.totalTracking / this.countchunk)
              let shipments = payload.param.shipment;
              let data = {
                param: {
                  document_type: payload.param.document_type,
                  shipment: shipments,
                  round: this.countchunk,
                  uuid: payload.param.uuid,
                  client_id: this.$store.state.websocket.uuid
                }
              }
              if (payload.param.print_page_size) {
                data.param.print_page_size = payload.param.print_page_size;
              }
              this.printRound++
              try {
                  let response = await Api.Shipment.printShippingLabel(data);
                  response = response.data;
                  if (!response.status) {
                      this.showLogError = true;
                  }
              } catch (err) {
                  console.error(err);
                  let message = err.response.message ? err.response.message : err.response.statusText;
                  response = {
                      status: false,
                      message: message
                  }
                  this.showLogError = true;
              }
        },
        async openWebsocket(){
          let vm = this;
          vm.showLogError = false;
          vm.showLogPrint = false;

          vm.refreshIntervalId = setInterval(function () {
            if(vm.countProgress >= vm.countPrintTracking){
              vm.countPrintTracking++
            }
          }, 100);

          let e = vm.listDataPrint;
          if(e && e.status){
            if (e && Object.keys(e).length > 0) {
              let round = e.data.round.split("-");
              if(vm.printedList.length < vm.loopPrint){
                if(this.totalTracking > this.countchunk){
                  vm.mergePrintList.push({
                    path: e.data.path,
                    number: round[0]
                  })
                }else{
                  vm.completePrintList.push({
                    url: e.data.url,
                    round: e.data.round,
                    file_name: e.data.file_name
                  })
                  vm.complete = true;
                  vm.showLogPrint = true;
                }

                vm.mergePrintList.sort((a, b) => parseInt(a.number) - parseInt(b.number));
                if(e.data.data.all_unprintable_list.length > 0){
                  e.data.data.all_unprintable_list.forEach((shipment) => {
                    vm.errorPrintList.push({
                      order_number: shipment
                    });
                  });
                }

                let successData = 'success'
                vm.printedList.push(successData);
                vm.countRound = Math.floor(this.printRound * this.countchunk);
                if (vm.countRound > vm.totalTracking) {
                    vm.countRound = vm.totalTracking;
                }

                vm.countProgress = (vm.countRound / this.totalTracking) * 100;
                vm.countCreateTracking = vm.countPrintTracking;
              }

              vm.printRound++

              if(vm.countProgress >= 100){
                vm.countPrintTracking = 100
                if(vm.errorPrintList.length > 0){
                  vm.showLogError = true;
                }

                const uuidV4 = uuid.v4()
                let data = {
                    file_name: new Date().toISOString().replace(/T/, '_').replace(/:/g, '-').split('.')[0] + '_' + uuidV4.substring(0, 13) + '_(1-'+this.totalTracking+')',
                    merge_list: vm.mergePrintList.map(item => item.path),
                }
                
                if(this.totalTracking > this.countchunk){
                  try {
                    let response = await Api.Shipment.mergeShippingLabel(data);
                    response = response.data;

                    if(response.status){
                        vm.completePrintList.push({
                          url: response.data.url,
                          file_name: response.data.file_name,
                          path: response.data.path
                        })
                        vm.showLogPrint = true;
                    }
                  } catch (err) {
                      console.error(err);
                      let message = err.response.message ? err.response.message : err.response.statusText;
                      response = {
                          status: false,
                          message: message
                      }
                      this.showLogError = true;
                  }
                }

                setTimeout(() => {
                  clearInterval(vm.refreshIntervalId);
                }, 1000);
                vm.complete = true;
              } 
            }
          }
        },
      formatFileName(name){
        let fileName = name ? name.replaceAll("_"," ") : '';
        return fileName;
      },
    },
    mounted() {
      this.generateLabelFunc();
    },
    filters: {
    },
}
</script>

<style scoped>
a.custom-hover {
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/shipment/ModalPrintTiktok.vue